








































































































































































































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import moment from 'moment'
import AppDialog from './AppDialog.vue'
import AuthFilter from '@/mixins/auth-filter'
import { dispatchClearPage, dispatchUpdateIfNewOrders } from '@/store/dispatches'
import gql from 'graphql-tag'
import { State } from 'vuex-class'
import { IfNewOrders } from '@/interfaces/ifNewOrders'

interface SubItem {
  title: string;
  routeTo: string;
  role: string[];
}

interface MenuItem {
  title: string;
  icon: any;
  routeTo?: string;
  subList: SubItem[];
  role: string[];
}

@Component({
  components: {
    AppDialog
  }
})
export default class AppDrawer extends mixins(AuthFilter) {
  drawer = null;
  items: MenuItem[] = [
    {
      title: '商品管理',
      icon: require('@/assets/icon_menu_book.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [
        {
          title: '商品品类',
          routeTo: 'GoodsList',
          role: ['ROOT', 'ADMIN', 'DEALER']
        }
      ]
    },
    {
      title: '订单管理',
      icon: require('@/assets/icon_menu_order.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [
        {
          title: '订单',
          routeTo: 'OrderList',
          role: ['ROOT', 'ADMIN', 'DEALER']
        },
        {
          title: '申请退款订单',
          routeTo: 'RefundOrder',
          role: ['ROOT', 'ADMIN', 'DEALER']
        },
        {
          title: '线上退款审核',
          routeTo: 'RefundAudit',
          role: ['ROOT', 'ADMIN']
        },
        {
          title: '退款单',
          routeTo: 'RefundList',
          role: ['ROOT', 'ADMIN', 'DEALER']
        },
        {
          title: '佣金管理',
          routeTo: 'ProfitSharingsList',
          role: ['ROOT', 'ADMIN', 'DEALER']
        }
      ]
    },
    {
      title: '学校管理',
      icon: require('@/assets/icon_menu_school.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [
        {
          title: '学校',
          routeTo: 'SchoolList',
          role: ['ROOT', 'ADMIN', 'DEALER']
        }
      ]
    },
    {
      title: '经销商管理',
      icon: require('@/assets/icon_menu_dealer.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [
        {
          title: '经销商',
          role: ['ROOT', 'ADMIN', 'DEALER'],
          routeTo: 'DealerList'
        }
      ]
    },
    {
      title: '会员管理',
      icon: require('@/assets/icon_menu_device.png'),
      role: ['ROOT', 'ADMIN'],
      subList: [
        {
          title: '会员',
          role: ['ROOT', 'ADMIN'],
          routeTo: 'MemberList'
        }
      ]
    },
    {
      title: '设置',
      icon: require('@/assets/icon_menu_gear.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [
        {
          title: '修改密码',
          role: ['ROOT', 'ADMIN', 'DEALER'],
          routeTo: 'ChangePassword'
        },
        {
          title: '管理员列表',
          role: ['ROOT', 'ADMIN'],
          routeTo: 'ManagerList'
        },
        {
          title: '征订周期',
          role: ['ROOT', 'ADMIN'],
          routeTo: 'SubscriptionCycle'
        }
      ]
    }
  ];

  subItems: SubItem[] = [];
  current = -1;

  menuMap: { [key: string]: any } = {};

  folded = false;

  subListShow = false;
  subListPos = { x: 0, y: 0 };

  @State((state) => state.snacks.ifNewOrders) ifNewOrders!: IfNewOrders;

  mounted () {
    this.getOrderViewHistory()
    let start = 0
    let end = -1
    const routeMap: {
      [key: string]: {
        parentIndex: number;
        totalIndex: number;
      };
    } = {}

    const items = this.items.map((item, index) => {
      end += 1
      start = end
      if (item.subList) {
        const subList = item.subList.map((sItem) => {
          end += 1
          routeMap[sItem.routeTo] = {
            parentIndex: index,
            totalIndex: end
          }
          return Object.assign({}, sItem, {
            active: end
          })
        })
        item.subList = subList
      } else {
        routeMap[item.routeTo as string] = {
          parentIndex: index,
          totalIndex: start
        }
      }
      this.menuMap[item.title] = {
        s: start,
        e: end
      }
      return Object.assign({}, item, {
        active: start
      })
    })

    this.items = items
    const routeName = this.$route.name

    this.current = routeMap[routeName as string]
      ? routeMap[routeName as string].totalIndex
      : 1

    const parentIndex = routeMap[routeName as string]
      ? routeMap[routeName as string].parentIndex
      : 0

    this.handleClick(items[parentIndex], parentIndex)
  }

  fold () {
    this.folded = !this.folded
    this.subItems = []
  }

  routeTo (routeName: string, params = {}) {
    dispatchClearPage(this.$route.name as string)
    if (routeName === this.$route.name) {
      return
    }
    this.$router
      .push({
        name: routeName,
        params
      })
      .catch((err) => err)
  }

  handleClick (item: any, index: number): void {
    const menuList = this.$refs.menuList as Element[]
    if (!menuList) {
      return
    }
    const pos = menuList[index].getBoundingClientRect()
    if (item.active === this.current) {
      this.subListShow = false
      this.subItems = []
      this.subListPos = { x: 0, y: 0 }
      this.current = -1
    } else {
      this.subListPos.x = 66
      this.subListPos.y = pos.y
      this.subItems = item.subList
      this.subListShow = true
      this.current = item.active
    }
  }

  handleClickSubItem (subItem: any): void {
    this.current = subItem.active
    this.routeTo(subItem.routeTo)
    this.subItems = []
  }

  utcDateTimeToLocal (date: string) {
    return moment.utc(date).local().format('D-M-YYYY H:mm')
  }

  async getOrderViewHistory () {
    const result = await this.$apollo.query({
      query: gql`
        query {
          getNewOrders {
            order
            refund
            refundApplication
            refundAudit
          }
        }
      `
    })
    if (result) {
      dispatchUpdateIfNewOrders(result.data.getNewOrders)
    }
  }

  showRedDot (item: SubItem) {
    const { order, refund, refundApplication, refundAudit } = this.ifNewOrders
    const { routeTo } = item

    if (routeTo === 'OrderList' && order) {
      return true
    }

    if (routeTo === 'RefundOrder' && refundApplication) {
      return true
    }

    if (routeTo === 'RefundAudit' && refundAudit) {
      return true
    }

    if (routeTo === 'RefundList' && refund) {
      return true
    }

    return false
  }
}
